import { render, staticRenderFns } from "./ata-rangi.vue?vue&type=template&id=6c4f2a9e&scoped=true"
import script from "./ata-rangi.vue?vue&type=script&lang=js"
export * from "./ata-rangi.vue?vue&type=script&lang=js"
import style0 from "./ata-rangi.vue?vue&type=style&index=0&id=6c4f2a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4f2a9e",
  null
  
)

export default component.exports